import { LogicNameFilter } from "../../../../../utils/constants";
import {
  ALL_OPTION_NAME,
  filterName,
  pastTimeValues,
  terminationTimeOption,
  terminationTimeValues,
} from "../utils";

const {
  getUserLastActiveTimestamp,
  getIsAdminList,
  getUserTerminationTimestamp,
} = require("../../../../../utils/search");
const {
  getTimestampXDaysAgo,
  getTimestampXDaysInFuture,
} = require("../../../../../utils/timestamp");

const getUserPoliciesWithSources = (entity) => {
  const userPoliciesWithSources = [];
  if (entity?.crowdstrike_data?.policies) {
    userPoliciesWithSources.push(
      ...entity.crowdstrike_data.policies.map(
        (p) => `${p.policy_name}__crowdstrike`
      )
    );
  }
  if (entity?.okta_data?.policies) {
    userPoliciesWithSources.push(
      ...entity.okta_data.policies.map((p) => `${p.policy_name}__okta`)
    );
  }
  if (entity?.aws_data?.policies) {
    userPoliciesWithSources.push(
      ...entity.aws_data.policies.map((p) => `${p.policy_name}__aws`)
    );
  }
  return userPoliciesWithSources;
};

export const applyUserFilters = (
  entities,
  appliedFilters,
  filterAndOrLogics
) => {
  let filteredEntities = [...entities];

  // Department
  if (
    filterName.DEPARTMENT in appliedFilters &&
    Object.keys(appliedFilters[filterName.DEPARTMENT]).length > 0
  ) {
    const checkedDepartments = Object.keys(
      appliedFilters[filterName.DEPARTMENT]
    ).filter((key) => appliedFilters[filterName.DEPARTMENT][key]);
    if (checkedDepartments.length > 0) {
      filteredEntities = filteredEntities.filter((entity) => {
        const userDepartment =
          entity.hibob_data?.department ||
          entity?.bamboohr_data?.department ||
          entity?.kandji_data?.department;
        return checkedDepartments.includes(userDepartment);
      });
    }
  }

  // Privileged in
  if (
    filterName.PRIVILEGED_IN in appliedFilters &&
    Object.keys(appliedFilters[filterName.PRIVILEGED_IN]).length > 0
  ) {
    const checkedTools = Object.keys(
      appliedFilters[filterName.PRIVILEGED_IN]
    ).filter((key) => appliedFilters[filterName.PRIVILEGED_IN][key] === true);
    if (checkedTools.length > 0) {
      if (
        filterAndOrLogics[filterName.PRIVILEGED_IN] === LogicNameFilter.LOGIC_OR
      ) {
        filteredEntities = filteredEntities.filter(
          (entity) =>
            entity?.admin_roles &&
            checkedTools.some((tool) => getIsAdminList(entity).includes(tool))
        );
      } else if (
        filterAndOrLogics[filterName.PRIVILEGED_IN] ===
        LogicNameFilter.LOGIC_AND
      ) {
        filteredEntities = filteredEntities.filter(
          (entity) =>
            entity?.admin_roles &&
            checkedTools
              .filter((tool) => tool !== ALL_OPTION_NAME)
              .every((tool) => getIsAdminList(entity).includes(tool))
        );
      }
    }
  }

  // Okta Admins
  if (
    filterName.OKTA_ADMINS in appliedFilters &&
    Object.keys(appliedFilters[filterName.OKTA_ADMINS]).length > 0
  ) {
    const checkedRoles = Object.keys(
      appliedFilters[filterName.OKTA_ADMINS]
    ).filter((key) => appliedFilters[filterName.OKTA_ADMINS][key] === true);
    if (checkedRoles.length > 0) {
      if (
        filterAndOrLogics[filterName.OKTA_ADMINS] === LogicNameFilter.LOGIC_OR
      ) {
        filteredEntities = filteredEntities.filter(
          (entity) =>
            entity?.admin_roles?.okta &&
            checkedRoles.some((role) => entity.admin_roles.okta.includes(role))
        );
      } else if (
        filterAndOrLogics[filterName.OKTA_ADMINS] === LogicNameFilter.LOGIC_AND
      ) {
        filteredEntities = filteredEntities.filter(
          (entity) =>
            entity?.admin_roles?.okta &&
            checkedRoles.every((role) => entity.admin_roles.okta.includes(role))
        );
      }
    }
  }

  // Okta Groups
  if (
    filterName.OKTA_GROUPS in appliedFilters &&
    Object.keys(appliedFilters[filterName.OKTA_GROUPS]).length > 0
  ) {
    const checkedGroups = Object.keys(
      appliedFilters[filterName.OKTA_GROUPS]
    ).filter((key) => appliedFilters[filterName.OKTA_GROUPS][key] === true);
    if (checkedGroups.length > 0) {
      if (
        filterAndOrLogics[filterName.OKTA_GROUPS] === LogicNameFilter.LOGIC_OR
      ) {
        filteredEntities = filteredEntities.filter(
          (entity) =>
            entity?.okta_data?.groups &&
            Array.isArray(entity.okta_data.groups) &&
            checkedGroups.some((group) =>
              entity.okta_data.groups.some(
                (oktaGroup) => oktaGroup?.name === group
              )
            )
        );
      } else if (
        filterAndOrLogics[filterName.OKTA_GROUPS] === LogicNameFilter.LOGIC_AND
      ) {
        filteredEntities = filteredEntities.filter(
          (entity) =>
            entity?.okta_data?.groups &&
            Array.isArray(entity.okta_data.groups) &&
            checkedGroups.every((group) =>
              entity.okta_data.groups.some(
                (oktaGroup) => oktaGroup?.name === group
              )
            )
        );
      }
    }
  }

  // Okta Status
  if (
    filterName.OKTA_STATUS in appliedFilters &&
    Object.keys(appliedFilters[filterName.OKTA_STATUS]).length > 0
  ) {
    const checkedStatuses = Object.keys(
      appliedFilters[filterName.OKTA_STATUS]
    ).filter((key) => appliedFilters[filterName.OKTA_STATUS][key] === true);
    if (checkedStatuses.length > 0) {
      if (
        filterAndOrLogics[filterName.OKTA_STATUS] === LogicNameFilter.LOGIC_OR
      ) {
        filteredEntities = filteredEntities.filter(
          (entity) =>
            entity?.okta_data?.status &&
            checkedStatuses.some((status) =>
              entity.okta_data.status.includes(status)
            )
        );
      } else if (
        filterAndOrLogics[filterName.OKTA_STATUS] === LogicNameFilter.LOGIC_AND
      ) {
        filteredEntities = filteredEntities.filter(
          (entity) =>
            entity?.okta_data?.status &&
            checkedStatuses.every((status) =>
              entity.okta_data.status.includes(status)
            )
        );
      }
    }
  }

  // Policies
  if (
    filterName.POLICIES in appliedFilters &&
    Object.keys(appliedFilters[filterName.POLICIES]).length > 0
  ) {
    const checkedPolicyKeys = Object.keys(
      appliedFilters[filterName.POLICIES]
    ).filter((key) => appliedFilters[filterName.POLICIES][key] === true);
    if (checkedPolicyKeys.length > 0) {
      if (filterAndOrLogics[filterName.POLICIES] === LogicNameFilter.LOGIC_OR) {
        filteredEntities = filteredEntities.filter((entity) => {
          const userPoliciesWithSources = getUserPoliciesWithSources(entity);
          return checkedPolicyKeys.some((policyKey) =>
            userPoliciesWithSources.includes(policyKey)
          );
        });
      } else if (
        filterAndOrLogics[filterName.POLICIES] === LogicNameFilter.LOGIC_AND
      ) {
        filteredEntities = filteredEntities.filter((entity) => {
          const userPoliciesWithSources = getUserPoliciesWithSources(entity);
          return checkedPolicyKeys.every((policyKey) =>
            userPoliciesWithSources.includes(policyKey)
          );
        });
      }
    }
  }

  // Last active
  if (
    filterName.LAST_ACTIVE in appliedFilters &&
    filterName.LAST_ACTIVE in filterAndOrLogics &&
    Object.keys(appliedFilters[filterName.LAST_ACTIVE]).length > 0
  )
    filteredEntities = filteredEntities.filter((entity) => {
      const lastActiveTimestamp = getUserLastActiveTimestamp(entity);
      if (!lastActiveTimestamp) return false;
      let selectedTimestamp = 0;
      for (const [name, info] of Object.entries(pastTimeValues)) {
        if (appliedFilters[filterName.LAST_ACTIVE][name])
          selectedTimestamp = getTimestampXDaysAgo(info.days);
      }
      if (
        filterAndOrLogics[filterName.LAST_ACTIVE] === LogicNameFilter.TIME_AFTER
      )
        return lastActiveTimestamp > selectedTimestamp;
      else if (
        filterAndOrLogics[filterName.LAST_ACTIVE] ===
        LogicNameFilter.TIME_BEFORE
      )
        return lastActiveTimestamp < selectedTimestamp;
      else return false;
    });

  // Connected Hosts Count (for smart filter)
  if (
    filterName.CONNECTED_HOSTS_COUNT in appliedFilters &&
    Object.keys(appliedFilters[filterName.CONNECTED_HOSTS_COUNT]).length > 0
  ) {
    const checkedCounts = Object.keys(
      appliedFilters[filterName.CONNECTED_HOSTS_COUNT]
    ).filter(
      (key) => appliedFilters[filterName.CONNECTED_HOSTS_COUNT][key] === true
    );

    if (checkedCounts.length > 0) {
      filteredEntities = filteredEntities.filter((entity) => {
        const connectedHostsCount = entity.hosts_ids?.length || 0;
        return checkedCounts.includes(connectedHostsCount.toString());
      });
    }
  }

  // Termination Date
  if (
    filterName.TERMINATION_DATE in appliedFilters &&
    Object.keys(appliedFilters[filterName.TERMINATION_DATE]).length > 0
  ) {
    const selectedOption = Object.keys(
      appliedFilters[filterName.TERMINATION_DATE]
    ).find((key) => appliedFilters[filterName.TERMINATION_DATE][key] === true);

    if (selectedOption) {
      const now = Date.now() / 1000;
      filteredEntities = filteredEntities.filter((entity) => {
        const terminationDate = getUserTerminationTimestamp(entity);

        if (!terminationDate) return false;

        if (selectedOption === terminationTimeOption.ALREADY_TERMINATED) {
          return terminationDate < now;
        }

        const timeConfig = terminationTimeValues[selectedOption];
        if (!timeConfig) return false;

        if (timeConfig.days === null) {
          return terminationDate > now;
        }

        const futureTimestamp = getTimestampXDaysInFuture(timeConfig.days);
        return terminationDate > now && terminationDate <= futureTimestamp;
      });
    }
  }

  entities.length = 0;
  for (let i = 0; i < filteredEntities.length; i++) {
    entities[i] = filteredEntities[i];
  }
};
